import { atom } from 'recoil';

export const activePermitsListState = atom({
    key: 'activePermitsListState',
    default: [],
});

export const activePermitsSearchState = atom({
    key: 'activePermitsSearchState',
    default: '',
});
